import { createBrowserRouter } from "react-router-dom";
import Home from "../pages/home/Home";
import Navbar from "../layout/Navbar";
import Footer from "../layout/Footer";
import { WebsiteInDevelopment } from '../pages/comming-soon/WebsiteInDevelopment'
import { Sitemap } from 'react-router-sitemap'

export const urls = {
  Home: '/',
  SignUp: '/sign-up',
  LogIn: '/log-in'
}

const router = createBrowserRouter([
  {
    path: urls.Home,
    element: 
        <>
          <Navbar/> 
          <Home/>
          <Footer/>
          {/* <WebsiteInDevelopment/> */}
        </>
}, 
  

])

export default router